import React from 'react';
import { motion } from 'framer-motion';
import Logo from './Logo';

const Footer = () => (
  <footer className="relative border-t border-black/10 px-6 sm:px-10 py-12" data-testid="main-footer">
    <div className="max-w-7xl mx-auto flex flex-col items-center text-center gap-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      >
        <Logo className="h-8" testId="footer-logo" />
      </motion.div>
      <p className="text-sm text-[#6e6a63]">
        Order direct. Support local. <span className="text-[#97917f]">— DineOra</span>
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs text-[#71716b]">
        <a href="https://dineora.ca" target="_blank" rel="noreferrer" className="hover:text-[#f15a24] transition-colors duration-200" data-testid="footer-link-website">
          dineora.ca
        </a>
        <a href="https://dineora.ca/join" target="_blank" rel="noreferrer" className="hover:text-[#f15a24] transition-colors duration-200" data-testid="footer-link-restaurants">
          For restaurants
        </a>
        <a href="mailto:hello@dineora.ca" className="hover:text-[#f15a24] transition-colors duration-200" data-testid="footer-link-contact">
          hello@dineora.ca
        </a>
      </div>
      <p className="text-[11px] text-[#9a948a]">
        © 2026 KeAnu Inc., operating as DineOra. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
